import ReactAudioPlayer from 'react-audio-player';
import instruction from '../assets/audio/headphone_instructions.mp3';
import { shallowEqual, useSelector } from 'react-redux';
import MediaService from '../../../../services/MediaService';
import './SingingIntroduction.scss';

const SingingIntroduction = ({ onBackClick, onNextClick }) => {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const headphoneIcon = MediaService.getImage(
    '/Module1Images/Icon_Headphones_Blue.png',
    login
  );

  return (
    <section className='sing-introduction'>
      <ReactAudioPlayer src={instruction} autoPlay />
      <header>
        <h1>Day 4</h1>
        <h2>
          You will be recording the social skill song. In order to have better
          quality, sing the song while using headphones.
        </h2>
      </header>
      <figure>
        <img src={headphoneIcon} alt='headphoneIcon' />
      </figure>
      <footer>
        <button className='link-button' onClick={onBackClick}>
          &#60; BACK
        </button>
        <button className='link-button' onClick={onNextClick}>
          NEXT &#62;
        </button>
      </footer>
    </section>
  );
};

export default SingingIntroduction;
